var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPlacementOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1 24C18.6029 24 18.2 23.5971 18.2 23.1V20H5.8V23.1C5.8 23.5971 5.39706 24 4.9 24C4.40294 24 4 23.5971 4 23.1L4 20H0.899999C0.402943 20 0 19.5971 0 19.1C0 18.6029 0.402944 18.2 0.9 18.2H4L4 5.8H0.899999C0.402943 5.8 0 5.39706 0 4.9C0 4.40294 0.402944 4 0.9 4H4L4 0.899999C4 0.402943 4.40294 0 4.9 0C5.39706 0 5.8 0.402944 5.8 0.9V4H18.1999V0.899999C18.1999 0.402943 18.6029 0 19.1 0C19.597 0 20 0.402944 20 0.9V4H23.1C23.5971 4 24 4.40294 24 4.9C24 5.39706 23.5971 5.8 23.1 5.8H20V18.2H23.1C23.5971 18.2 24 18.6029 24 19.1C24 19.5971 23.5971 20 23.1 20H20V23.1C20 23.5971 19.597 24 19.1 24ZM18.2 18.2H5.8L5.8 5.8H18.1999L18.2 18.2ZM8 9.07317C8 8.48048 8.48048 8 9.07317 8H10.7805C11.2385 8 11.6098 8.37128 11.6098 8.82927C11.6098 9.28726 11.2385 9.65854 10.7805 9.65854H9.65854V14.3415H14.3415V13.7073C14.3415 13.2493 14.7127 12.878 15.1707 12.878C15.6287 12.878 16 13.2493 16 13.7073V14.9268C16 15.5195 15.5195 16 14.9268 16H9.07317C8.48048 16 8 15.5195 8 14.9268V9.07317ZM12.878 8.82927C12.878 8.37128 13.2493 8 13.7073 8H14.9268C15.5195 8 16 8.48048 16 9.07317V10.2927C16 10.7507 15.6287 11.122 15.1707 11.122C14.7127 11.122 14.3415 10.7507 14.3415 10.2927C14.3415 9.94245 14.0575 9.65854 13.7073 9.65854C13.2493 9.65854 12.878 9.28726 12.878 8.82927Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementOutlined);
export default __webpack_public_path__ + "static/media/placementOutlined.daeca47c48669426ac06bf6cfc94c808.svg";
export { ForwardRef as ReactComponent };